<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+VENTILATION.REMOTE_CONTROLLER.ADD_VITOTROL_DEVICE_HEADER' | translate }}</span>
      <button
        mat-icon-button
        gtm="onCancel"
        gtmAction="cancel"
        gtmCategory="assignVitotrolModal"
        (click)="onCancel()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <div class="content__description-section">
        <div class="description-section__header">
          {{ '+VENTILATION.REMOTE_CONTROLLER.ADD_VITOTROL_DEVICE_SUBTITLE' | translate }}
        </div>

        <div class="description-section__circuits">
          <mat-radio-group
            *ngIf="allCircuits"
            class="hc-selection__radio-group"
            [ngModel]="selectedOption"
            (ngModelChange)="onHcOptionSelect($event)"
          >
            <mat-radio-button *ngFor="let circuit of allCircuits" color="primary" [value]="circuit">
              <span class="radio__name"
                >{{
                  installationFeaturesStore.selectRemoteDeviceType(data.currentFeatureName) | async
                }}
                ({{ circuit | idPrefixRemover | serialSpacing }})</span
              >
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      gtm="onCancel"
      gtmAction="cancel"
      gtmCategory="assignVitotrolModal"
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      gtm="onConfirm"
      gtmAction="confirm"
      gtmCategory="assignVitotrolModal"
      mat-raised-button
      color="primary"
      [disabled]="!selectedOption"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
